import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import DottedBackground from "../../Common/imgGen/DottedBackground";
export const NAMESPACE = "documents";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
export const DOCUMENT_BG = {
    backgroundImage: DottedBackground(),
    backgroundColor: "#e7eeea"
};
